import React from "react";
import { Document, Page, Text, Font, View } from "@react-pdf/renderer";
import Annex from "./Annex";
import { styles } from "./AppStyleTax";
import { FooterPageNum } from "./HeaderFooter";
import { gen_day } from "../../utils/dayshow";

export default function DocumentTax({ data_pdf }) {
  Font.register({
    family: "timesnewroman_bold_italic",
    src: "./fonts/times new roman bold italic.ttf",
  });
  Font.register({
    family: "timesnewroman_italic",
    src: "./fonts/times new roman italic.ttf",
  });
  Font.register({
    family: "timesnewroman_regular",
    src: "./fonts/SVN-Times New Roman.ttf",
  });
  Font.register({
    family: "timesnewroman_bold",
    src: "./fonts/SVN-Times New Roman Bold.ttf",
  });

  if (data_pdf == null) {
    return null;
  } else {
    const day_showing = gen_day(data_pdf.day_start, data_pdf.activities.length);
    const title_pdf = data_pdf.booking_number + ".pdf";

    return (
      <Document title={title_pdf}>
        <Page style={styles.body} wrap>
          {/* <HeaderCus /> */}
          <Text style={styles.title}>HỢP ĐỒNG DỊCH VỤ</Text>
          <Text style={styles.title_italic}>SERVICE AGREEMENT</Text>

          <Text style={styles.normal}>
            Số/ No: {data_pdf.tax_data.contract_number}
          </Text>
          <Text style={styles.normal}>
            Hôm nay, ngày {data_pdf.tax_data.contract_date_day} tháng{" "}
            {data_pdf.tax_data.contract_date_month} năm{" "}
            {data_pdf.tax_data.contract_date_year} tại{" "}
            <Text style={styles.normal_bold}>
              CÔNG TY TNHH DU LỊCH KHÁM PHÁ S VIỆT NAM
            </Text>
            , chúng tôi gồm:
          </Text>
          <Text style={styles.normal_italic}>
            Today, date {data_pdf.tax_data.contract_date_day} month{" "}
            {data_pdf.tax_data.contract_date_month} year{" "}
            {data_pdf.tax_data.contract_date_year} at{" "}
            <Text style={styles.normal_bold_italic}>
              S VIETNAM ADVENTURES TRAVEL COMPANY LIMITED
            </Text>
            , the parties include:
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              BÊN A:
            </Text>{" "}
            CÔNG TY TNHH DU LỊCH KHÁM PHÁ S VIỆT NAM
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              PARTY A:
            </Text>{" "}
            S VIETNAM ADVENTURES TRAVEL COMPANY LIMITED
          </Text>
          <Text style={styles.normal}>
            Mã số thuế{" "}
            <Text style={styles.normal_italic}>/Tax code: 0110033093</Text>
          </Text>
          <Text style={styles.normal}>
            Địa chỉ: Số 3, ngách 2, ngõ 228 đường Thanh Bình, Phường Hà Đông,
            Thành phố Hà Nội, Việt Nam
          </Text>
          <Text style={styles.normal_italic}>
            Address: No. 3, Lane 2, Alley 228, Thanh Binh street, Ha Dong
            district, Hanoi, Vietnam
          </Text>
          <Text style={styles.normal}>
            Điện thoại <Text style={styles.normal_italic}>/Telephone</Text>:
            +8484579384
          </Text>
          <Text style={styles.normal}>
            Đại diện <Text style={styles.normal_italic}>/Represented</Text>:{" "}
            <Text style={styles.normal_bold}>Ông/Mrs. PHẠM ĐỨC LUÂN</Text>
          </Text>
          <Text style={styles.normal}>
            Chức vụ <Text style={styles.normal_italic}>/Position</Text>: Giám
            Đốc
          </Text>
          <Text style={styles.normal}>
            (Sau đây gọi là “<Text style={styles.normal_bold}>Bên A</Text>”/
            <Text style={styles.normal_italic}>
              Hereinafter referred to as “
            </Text>
            <Text style={styles.normal_bold}>Party A</Text>”)
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              BÊN B:
            </Text>{" "}
            {data_pdf.tax_data.customer_name}
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              PARTY B:
            </Text>{" "}
            {data_pdf.tax_data.customer_name}
          </Text>
          <Text style={styles.normal}>
            Địa chỉ /<Text style={styles.normal_italic}>Address:</Text>{" "}
            {data_pdf.tax_data.customer_address}
          </Text>
          <Text style={styles.normal}>
            Điện thoại <Text style={styles.normal_italic}>/ Telephone</Text>:{" "}
            {data_pdf.tax_data.customer_phone}
          </Text>
          <Text style={styles.normal}>
            Đại diện <Text style={styles.normal_italic}>/ Represented</Text>:{" "}
            <Text style={styles.normal_bold}>
              {data_pdf.tax_data.customer_name}
            </Text>
          </Text>
          <Text style={styles.normal}>
            (Sau đây gọi là “<Text style={styles.normal_bold}>Bên B</Text>”/
            <Text style={styles.normal_italic}>
              Hereinafter referred to as “
            </Text>
            <Text style={styles.normal_bold}>Party B</Text>”)
          </Text>

          <Text style={styles.normal}>
            Sau khi thoả thuận, Các Bên thống nhất ký kết Hợp đồng Dịch Vụ{" "}
            <Text style={styles.normal_bold}>("Hợp Đồng")</Text> với các nội
            dung sau đây:
          </Text>
          <Text style={styles.normal_italic}>
            After the agreement, the Parties agreed to sign a Service Agreement{" "}
            <Text style={styles.normal_bold}>("Agreement")</Text> with the
            following contents:
          </Text>

          {/* ĐIỀU 1.	NỘI DUNG HỢP ĐỒNG */}
          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 1
            </Text>
            . NỘI DUNG HỢP ĐỒNG
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 1
            </Text>
            . CONTENT OF AGREEMENT
          </Text>

          {/* 1.1	Bên A cung cấp dịch vụ tham quan, du lịch Việt Nam, vé máy bay cho bên B. */}
          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>1.1</Text>
            {"     "}Bên A cung cấp dịch vụ tham quan, du lịch Việt Nam, vé máy
            bay cho bên B.
          </Text>
          <Text style={styles.normal_italic}>
            Party A provides sightseeing services, and tourist services in
            Vietnam, airline ticket for Party B.
          </Text>

          {/* 1.2	Dịch vụ cụ thể được Bên A chuẩn bị và thông báo chi tiết cho Bên B, được Bên B chấp nhận và được xem như là một phần không thể tách rời của Hợp Đồng này, có cùng thời hạn hiệu lực với Hợp Đồng */}
          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>1.2</Text>
            {"     "}Dịch vụ cụ thể được Bên A chuẩn bị và thông báo chi tiết
            cho Bên B, được Bên B chấp nhận và được xem như là một phần không
            thể tách rời của Hợp Đồng này, có cùng thời hạn hiệu lực với Hợp
            Đồng
          </Text>
          <Text style={styles.normal_italic}>
            The specific service prepared by Party A and informed to Party B in
            detail will be accepted by Party B and be considered an integral
            part of this Agreement, with the same deadline for the Agreement’s
            validity.
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 2
            </Text>
            . SỐ LƯỢNG, GIÁ CẢ VÀ GIÁ TRỊ HỢP ĐỒNG
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 2
            </Text>
            . QUANTITY AND PRICE AND AGREEMENT VALUE
          </Text>
          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>2.1</Text>
            {"     "}Số lượng khách: {data_pdf.no_of_client.split(" ")[0]} khách
          </Text>
          <Text style={styles.normal_italic}>
            Number of guests: {data_pdf.no_of_client.split(" ")[0]} guests
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>2.2</Text>
            {"     "}Giá cả và giá trị Hợp Đồng:
          </Text>
          <Text style={styles.normal_italic}>Price and Agreement Value:</Text>

          <Text style={styles.normal}>
            Theo Phụ lục 1 đính kèm hợp đồng này.
          </Text>
          <Text style={styles.normal_italic}>
            As per Annex 1 attached with this agreement
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 4
            </Text>
            . ĐIỀU KHOẢN THANH TOÁN
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 4
            </Text>
            . TERMS OF PAYMENT
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>4.1</Text>
            {"     "}Đồng tiền thanh toán: Đồng tiền được sử dụng để thanh toán
            là Việt Nam Đồng.
          </Text>
          <Text style={styles.normal_italic}>
            Payment Currency: The currency used for payment is Vietnam Dong
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>4.2</Text>
            {"     "}Phương thức thanh toán/
            <Text style={styles.normal_italic}>Terms of payment:</Text>
          </Text>
          <Text style={styles.normal}>
            Bên B thanh toán cho Bên A bằng chuyển khoản qua tài khoản hoặc tiền
            mặt.
          </Text>
          <Text style={styles.normal_italic}>
            Party B pays for Party A by cash or bank transfer.
          </Text>

          {/* 4.3	Tiến độ thanh toán: chi tiết tại phụ lục 1 đính kèm hợp đồng này */}
          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>4.3</Text>
            {"     "}Tiến độ thanh toán: chi tiết tại phụ lục 1 đính kèm hợp
            đồng này
          </Text>
          <Text style={styles.normal_italic}>
            Payment schedule: details as per Annex 1 attached with this
            agreement.
          </Text>

          {/* 4.4	Phạt chậm thanh toán/Late payment penalties: */}
          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>4.4</Text>
            {"     "}Phạt chậm thanh toán
            <Text style={styles.normal_italic}>/ Late payment penalties:</Text>
          </Text>

          <Text style={styles.normal}>
            Nếu Bên B không thanh toán đúng thời hạn như quy định trên thì ngoài
            việc Bên B phải chịu phạt vi phạm 8% trên phần nghĩa vụ bị vi phạm,
            Bên B phải chịu khoản tiền phạt chậm thanh toán theo lãi suất cơ bản
            bằng đồng Việt Nam do ngân hàng nhà nước Việt Nam công bố vào thời
            điểm thanh toán căn cứ trên tổng số tiền chậm thanh toán và thời
            gian chậm thanh toán.
          </Text>
          <Text style={styles.normal_italic}>
            If Party B does not pay on time as per the above provisions, Party B
            must pay a penalty of 8% of the breached obligation, Party B also
            must incur fines for late payment under the base rate Vietnam dong
            as the state bank of Vietnam announced at the time of payment based
            on the total amount of late payment and time for late payment.
          </Text>

          {/* ĐIỀU 5.	THẨM QUYỀN YÊU CẦU VÀ XÁC NHẬN DỊCH VỤ, CHI PHÍ PHÁT SINH */}
          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 5
            </Text>
            . THẨM QUYỀN YÊU CẦU VÀ XÁC NHẬN DỊCH VỤ, CHI PHÍ PHÁT SINH
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 5
            </Text>
            . COMPETENCE REQUIREMENTS AND SERVICE CONFIRMATION, COSTS INCURRED
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.1</Text>
            {"     "}Chi phí phát sinh: Là các chi phí do việc thực hiện các yêu
            cầu về dịch vụ phát sinh trong quá trình thực hiện Hợp Đồng nhưng
            không nằm trong chương trình du lịch đã được thỏa thuận trước đó,
            bao gồm nhưng không giới hạn các dịch vụ như: lưu trú, ăn uống, vận
            chuyển, dịch vụ khác, v.v
          </Text>
          <Text style={styles.normal_italic}>
            Costs incurred: All the expenses have been working really arise a
            demand for service during agreement performance but not in the prior
            travel program agreed, including but not limited to services such as
            accommodation, meals, transportation, and other services, etc.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.2</Text>
            {"     "}Thẩm quyền yêu cầu và xác nhận dịch vụ, chi phí phát sinh
            <Text style={styles.normal_italic}>
              Competence requirements and confirmation service costs incurred
            </Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.2.1</Text>
            {"   "}Bất kỳ yêu cầu về dịch vụ phát sinh nào từ phía khách hàng
            phải do Người đại diện có thẩm quyền của Bên B yêu cầu (trong trường
            hợp Đoàn khách chưa khởi hành) hoặc do Trưởng đoàn của Bên B yêu cầu
            với Trưởng đoàn của Bên A (trong trường hợp Đoàn khách đang khởi
            hành). Bên A sẽ xem xét và thực hiện dịch vụ phát sinh theo yêu cầu
            khách hàng trong phạm vi khả năng có thể.
          </Text>
          <Text style={styles.normal_italic}>
            Any request for services arising from the client must be required by
            the authorized representatives of Party B (in case of delegation not
            yet departed) or by the Head of the delegation of Party B requiring
            to the Head of the delegation of Party A (in the case of delegation
            is departing). Party A will review and implement services arising
            from the customer's requirements within the possibilities.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.2.2</Text>
            {"   "}Trong tường hợp Đoàn khách chưa khởi hành, việc yêu cầu dịch
            vụ phải được lập thành phụ lục Hợp Đồng có chữ ký xác nhận dịch vụ
            của đại diện có thẩm quyền của Các Bên.
          </Text>
          <Text style={styles.normal_italic}>
            In the case of the delegation not yet departed, the service request
            must be made in the appendix signed by authorized representatives of
            the two parties to confirm the service.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.2.3</Text>
            {"   "}Trong trường hợp Đoàn khách đang khởi hành, thì cùng với các
            Trưởng đoàn, mỗi Bên sẽ có hai người đại diện khác do Trưởng đoàn
            mỗi Bên chỉ định, để xác nhận và có trách nhiệm cùng ký vào bảng kê
            chi tiết các dịch vụ và các chi phí phát sinh tại thời điểm yêu cầu
            dịch vụ phát sinh.
          </Text>
          <Text style={styles.normal_italic}>
            In the event of delegation is departing, together with the Heads of
            the delegations, each Party will have two other representatives
            appointed by the Head of the delegation of each Party to confirm and
            be responsible for signing the detailing of the services and the
            expenses incurred at the time service arises.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.3</Text>
            {"     "}Thủ tục thanh toán chi phí phát sinh
            <Text style={styles.normal_italic}>
              /Procedure for payment of costs incurred:
            </Text>
          </Text>
          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.3.1</Text>
            {"   "}Phụ lục và/hoặc Biên bản có chữ ký xác nhận của Các Bên cùng
            với các hóa đơn, chứng từ hợp lệ sẽ là cơ sở để Bên B thanh toán các
            chi phí phát sinh sau khi kết thúc chương trình cùng với chi phí
            tour còn lại chưa thanh toán hết.
          </Text>
          <Text style={styles.normal_italic}>
            Appendix and/ or minutes of the confirmation signed by both Parties,
            along with the valid invoice, and documents will be the basis for
            Party B to pay the costs incurred after the end of the program,
            along with the cost of touring the remaining unpaid.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.3.2</Text>
            {"   "}Các Bên thống nhất rằng các dịch vụ và chi phí phát sinh
            trong quá trình thực hiện Hợp Đồng được xem như chi phí tour mà Bên
            B phải có trách nhiệm thanh toán sau khi kết thúc chương trình tour.
            Phần chi phí phát sinh được cộng dồn với số tiền tour còn lại mà Bên
            B chưa thanh toán và đưa vào thanh lý Hợp Đồng. Thời hạn thanh toán
            và giải quyết chậm thanh toán các chi phí này sẽ được áp dụng như
            chi phí tour mà Các Bên đã thỏa thuận tại các điều khoản thanh toán
            trong Hợp Đồng này.
          </Text>
          <Text style={styles.normal_italic}>
            Both Parties agreed that the services and expenses incurred in the
            course of the agreement performance are a cost tour that Party B is
            responsible for payment after the end of the tour. The costs
            incurred are accumulated with the remaining amount that Party B
            unpaid and put into the agreement liquidation. Term of payment and
            settlement of late payment charges will be applied as the cost of
            the tour that the two parties agreed on the payment terms of this
            Agreement.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>5.3.3</Text>
            {"   "}Trong một số trường hợp, vì một số lý do nào đó mà việc xác
            nhận các chi phí phát sinh không được thực hiện đúng theo quy trình
            nêu trên nhưng thực tế Bên B có yêu cầu và sử dụng dịch vụ phát sinh
            trong quá trình đi tour thì mọi phát sinh đó phải được thông qua bởi
            trưởng đoàn của Các Bên, và Bên B cũng phải có nghĩa vụ thanh toán
            đầy đủ các chi phí này cho Bên A.
          </Text>
          <Text style={styles.normal_italic}>
            In some cases, for some reason, the confirmation of the incurred
            costs does not comply with the above procedures, but the fact that
            Party B is required to use the incurred service during the tour, all
            arising must be approved by the Heads of delegations of both
            Parties, and Party B must also be obliged to pay the full cost of
            this to the Party A.
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 6
            </Text>
            . QUYỀN & TRÁCH NHIỆM CỦA BÊN A
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 6
            </Text>
            . RIGHTS AND RESPONSIBILITIES OF PARTY A
          </Text>

          <Text style={styles.normal_bold}>
            <Text style={styles.normal_bold}>6.1</Text>
            {"     "}Quyền của Bên A
            <Text style={styles.normal_bold_italic}> / Rights of Party A</Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.1.1</Text>
            {"   "}Quyền linh hoạt thay đổi chương trình hoặc dịch vụ mà không
            thông báo trước bằng văn bản trong trường hợp việc thay đổi này nhằm
            đảm bảo sự an toàn và lợi ích cho Bên B mà Bên A không có khả năng
            thông báo trước. Ngay sau khi thay đổi, Bên A sẽ thông báo cho người
            đại diện được chỉ định trước đó của Bên B biết về việc thay đổi và
            lý do của việc thay đổi bằng văn bản. Trưởng Đoàn của Bên B có trách
            nhiệm phối hợp với Bên A thực hiện chương trình.
          </Text>
          <Text style={styles.normal_italic}>
            The right to flexible to change the program or service without prior
            written notice if that the changes are meant to ensure the safety
            and benefits to Party B that Party A cannot notify in advance.
            Shortly after the change, Party A will notify the designated
            representative of Party B previously known about the change and the
            reasons for the change in writing. The Head of the delegation of
            Party B is responsible for coordinating with Party A to implement
            the program.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.1.2</Text>
            {"   "}Yêu cầu Bên B cung cấp danh sách khách đăng kí tham gia
            chuyến du lịch và các thông tin cần thiết của Đoàn như: hộ
            chiếu/CMND, ngày tháng năm sinh, và các thông tin cần thiết có liên
            quan đến chuyến đi ít nhất 07 ngày trước ngày khởi hành.
          </Text>
          <Text style={styles.normal_italic}>
            Request Party B provides a list of registered guests who
            participated in tours and information needed by teams such as
            passports/ID cards, date of birth and the necessary information
            related to the trip at least 07 days before departure.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.1.3</Text>
            {"   "}Quyền yêu cầu Bên B có sự hỗ trợ, phối hợp trong phạm vi thực
            hiện Hợp Đồng này khi phát sinh vấn đề có liên quan đến chuyến đi.
          </Text>
          <Text style={styles.normal_italic}>
            Has the right to request Party B supports and coordinates the
            implementation of the agreement when issues related to the trip.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.1.4</Text>
            {"   "}Bên A có quyền từ chối thực hiện các yêu cầu phát sinh ngoài
            chương trình, dịch vụ đã thỏa thuận trong Hợp Đồng với Bên B.
          </Text>
          <Text style={styles.normal_italic}>
            Party A has the right to refuse the requirements arising out of the
            program, the service agreed upon in the agreement with Party B.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.1.5</Text>
            {"   "}Yêu cầu Bên B thanh toán đầy đủ và đúng thời hạn đã thoả
            thuận.
          </Text>
          <Text style={styles.normal_italic}>
            Request Party B pays in full and on time as agreed.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.1.6</Text>
            {"   "}Chấm dứt Hợp Đồng nếu Bên B không thực hiện việc đặt cọc theo
            đúng quy định tại Khoản 3, Điều 4, Hợp Đồng này.
          </Text>
          <Text style={styles.normal_italic}>
            Terminate the agreement if Party B fails to comply with the advance
            as stipulated in Paragraph 3, Article 4 of this agreement.
          </Text>

          <Text style={styles.normal_bold}>
            <Text style={styles.normal_bold}>6.2</Text>
            {"     "}Trách nhiệm của Bên A
            <Text style={styles.normal_bold_italic}>
              {" "}
              / Responsibilities of Party A
            </Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.2.1</Text>
            {"   "}Bên A có trách nhiệm thực hiện các dịch vụ và các công việc
            có liên quan một cách đầy đủ phù hợp với các thỏa thuận trong Hợp
            Đồng.
            <Text style={styles.normal_italic}>
              {" "}
              / Party A is responsible for performing the services and the
              related work fully in line with the agreements in the Agreement.
            </Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.2.2</Text>
            {"   "}Bên A cử người làm người đại diện, chịu trách nhiệm thực hiện
            các dịch vụ đã thoả thuận trong Hợp Đồng và các thỏa thuận khác với
            Bên B trong suốt chuyến đi.
          </Text>
          <Text style={styles.normal_italic}>
            Party A appoints a representative, who is responsible for the
            implementation of the agreed services in the agreement and other
            agreements with Party B during the trip.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.2.3</Text>
            {"   "}Bên A có trách nhiệm cử đại diện làm Trưởng Đoàn để gặp gỡ và
            hướng dẫn các thủ tục, lễ nghi văn hóa cần thiết ở nơi đến tham
            quan, kể cả các hành vi vi phạm pháp luật cho khách của Bên B.
          </Text>
          <Text style={styles.normal_italic}>
            Party A is responsible for appointing representatives to be the Head
            of the delegation to meet and guide the procedure, and cultural
            rituals needed in places to visit, including legal violations of
            Party B’s Guests.
          </Text>

          <Text style={styles.normal_bold}>
            <Text style={styles.normal_bold}>6.3</Text>
            {"     "}Miễn trừ trách nhiệm của Bên A
            <Text style={styles.normal_bold_italic}>
              {" "}
              / Disclaimer of Party A
            </Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.3.1</Text>
            {"   "}Bên A không chịu bất cứ trách nhiệm gì đối với hành vi vi
            phạm của hành khách Bên B (nếu có) ở nơi đến tham quan, nơi công
            cộng, trên các phương tiện vận chuyển
          </Text>
          <Text style={styles.normal_italic}>
            Party A is not responsible for the violations of the passenger of
            Party B (if any) in visiting places, public places or means of
            transport
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.3.2</Text>
            {"   "}Bên A không chịu trách nhiệm liên quan đến sự thất lạc, hư
            hỏng, mất mát hành lý hay bất kỳ vật dụng cá nhân nào khác của hành
            khách Bên B trong suốt quá trình thực hiện dịch vụ.
          </Text>
          <Text style={styles.normal_italic}>
            Party A is not responsible for any loss, damage, or loss of luggage
            or any other personal belongings of the passenger of Party B during
            the performance of the service.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.3.3</Text>
            {"   "}Bên A không chịu trách nhiệm trong trường hợp Bên B tự làm
            thất lạc, mất Hộ chiếu/Visa, giấy tờ cá nhân khác trong hành trình
            du lịch. Tuy nhiên, Trưởng đoàn/Hướng dẫn viên Bên A sẽ hỗ trợ giải
            quyết vụ việc với tinh thần trách nhiệm cao.
          </Text>
          <Text style={styles.normal_italic}>
            Party A is not responsible in the case of Party B lost by
            themselves: passport/ Visa, or other personal documents in the
            travel itinerary. However, the Head of delegation/ Guides of Party A
            will assist in settlement of the case with a high sense of
            responsibility.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>6.3.4</Text>
            {"   "}Bên A không chịu trách nhiệm trong trường hợp các thành viên
            trong Đoàn khách tự ý tách đoàn mà không thông báo trước cho Trưởng
            đoàn và/hoặc hướng dẫn viên của Bên A biết.
          </Text>
          <Text style={styles.normal_italic}>
            Party A is not responsible in the case of members of the delegation
            arbitrarily separated without prior notice to the Head of the
            delegation and/ or the tour guide of Party A.
          </Text>

          {/* ĐIỀU 7. QUYỀN & TRÁCH NHIỆM CỦA BÊN B 
ARTICLE 7. RIGHTS & RESPONSIBILITIES OF PARTY B */}
          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 7
            </Text>
            . QUYỀN & TRÁCH NHIỆM CỦA BÊN B
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 7
            </Text>
            . RIGHTS & RESPONSIBILITIES OF PARTY B
          </Text>

          {/* 7.1	Quyền của Bên B/ Rights of Party B: */}
          <Text style={styles.normal_bold}>
            <Text style={styles.normal_bold}>7.1</Text>
            {"     "}Quyền của Bên B
            <Text style={styles.normal_bold_italic}> / Rights of Party B</Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.1.1</Text>
            {"   "}Được Bên A cung cấp các dịch vụ và chương trình tham quan
            đúng và đầy đủ theo các điều khoản đã thoả thuận về chất lượng, thời
            gian, địa điểm, v.v trong Hợp Đồng này và các văn bản đính kèm.
          </Text>
          <Text style={styles.normal_italic}>
            To be provided the services and tour properly and fully in
            accordance with the agreed terms of quality, time, location, etc. in
            this Agreement and the documents attached by Party A
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.1.2</Text>
            {"   "}Yêu cầu Bên A thực hiện các yêu cầu hợp lý của Bên B đã thỏa
            thuận trong Hợp Đồng và các thỏa thuận khác.
          </Text>
          <Text style={styles.normal_italic}>
            Requesting Party A to perform of reasonable requirements of Party B
            agreed in the Agreement and the other Agreements
          </Text>

          {/* 7.2	Trách nhiệm của Bên B/ Responsibilities of Party B: */}
          <Text style={styles.normal_bold}>
            <Text style={styles.normal_bold}>7.2</Text>
            {"     "}Trách nhiệm của Bên B
            <Text style={styles.normal_bold_italic}>
              {" "}
              / Responsibilities of Party B
            </Text>
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.1</Text>
            {"   "}Căn cứ số lượng khách theo Hợp Đồng này. Bên B phải cung cấp
            danh sách Đoàn khách đăng ký tham gia chương trình tour ít nhất 15
            ngày trước ngày khởi hành. Trong trường hợp số lượng khách tăng hơn
            danh sách đã đăng ký trước đó thì phải thông báo cho Bên A biết ít
            nhất 15 ngày trước ngày khởi hành. Tuỳ theo tình hình thực tế, Bên A
            sẽ xác nhận lại khả năng cung cấp thêm dịch vụ cho số khách tăng
            thêm này.
          </Text>
          <Text style={styles.normal_italic}>
            Based on the number of passengers under this agreement. Party B must
            provide a list of delegations participating in the program
            registration at least 15 days before the departure date. In case the
            number of passengers increases by more than a list of previously
            registered must notify Party A knows at least 15 days before the
            departure date. Depending on the actual situation, Party A will
            confirm the ability to provide additional services for this number
            of guests increased.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.2</Text>
            {"   "}Bên B có trách nhiệm cử người đại diện làm Trưởng Đoàn để
            phối hợp với Trưởng đoàn của Bên A trong quá trình tham quan và thay
            mặt cả Đoàn khách của Bên B giải quyết các vấn đề có liên quan trong
            chuyến đi.
          </Text>
          <Text style={styles.normal_italic}>
            Party B is responsible for appointing a representative to be the
            Head of the delegation to coordinate with the Head of the delegation
            of Party A during the tour and on behalf of the delegation of Party
            B to resolve the relevant issues on the trip.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.3</Text>
            {"   "}Trong thời gian tổ chức tham quan theo lịch trình, các thành
            viên trong đoàn không được tự ý tách đoàn (không đi cùng đoàn), nếu
            có yêu cầu thay đổi phải thông báo cho Trưởng đoàn và/hoặc hướng dẫn
            viên của Bên A biết.
          </Text>
          <Text style={styles.normal_italic}>
            During the scheduled visit, the delegation members not arbitrarily
            separated groups (not accompanying the group), and if required
            change must notify the Head of the delegation and/ or guides Party A
            knows.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.4</Text>
            {"   "}Thực hiện đúng việc thanh toán theo quy định tại Điều 4 của
            Hợp Đồng này.
          </Text>
          <Text style={styles.normal_italic}>
            Strictly payment as defined in Article 4 of this agreement.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.5</Text>
            {"   "}Tự quản lý và chịu trách nhiệm về hành lý hay bất kỳ vật dụng
            cá nhân trong suốt chuyến đi.
          </Text>
          <Text style={styles.normal_italic}>
            Self-management and responsible for any luggage or other personnel
            during the trip.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.6</Text>
            {"   "}Thông báo cho các thành viên trong đoàn về thời gian và địa
            điểm đón trả khách mà Bên A đã thông báo trước đó cho Bên B. Các
            thành viên trong đoàn có trách nhiệm có mặt đúng thời gian và địa
            điểm đón khách theo đúng thông báo.
          </Text>
          <Text style={styles.normal_italic}>
            Notice to the members of the delegation about the time and place
            where pick up and drop off that Party A previously announced for
            Party B. The team members have the responsibility to be present at
            the time and place of pickup in accordance with the notice.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.7</Text>
            {"   "}Số lượng khách không được giảm quá 5% so với số lượng ký Hợp
            Đồng.
          </Text>
          <Text style={styles.normal_italic}>
            The number of guests is not allowed to decrease by more than 5%
            compared to the number in the signed Agreement.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>7.2.8</Text>
            {"   "}Mua bảo hiểm du lịch cho các thành viên trong đoàn.
          </Text>
          <Text style={styles.normal_italic}>
            Buying travel insurance for members of Party B’s delegation.
          </Text>

          {/* ĐIỀU 8.	PHẠT VI PHẠM VÀ BỒI THƯỜNG THIỆT HẠI VÀ CÁC CHẾ TÀI KHÁC DO VI PHẠM HỢP ĐỒNG */}
          {/* ARTICLE 8. VIOLATIONS & DAMAGES COMPENSATION AND OTHER SANCTIONS BREACH OF AGREEMENT */}

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 8
            </Text>
            . PHẠT VI PHẠM VÀ BỒI THƯỜNG THIỆT HẠI VÀ CÁC CHẾ TÀI KHÁC DO VI
            PHẠM HỢP ĐỒNG
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 8
            </Text>
            . VIOLATIONS & DAMAGES COMPENSATION AND OTHER SANCTIONS BREACH OF
            AGREEMENT
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>8.1</Text>
            {"     "}Trong trường hợp Bên A không thực hiện được một phần hoặc
            toàn bộ các dịch vụ theo Hợp Đồng do lỗi của Bên A (trừ trường hợp
            bất khả kháng tại Điều 9) thì Bên A phải thông báo cho Bên B ít nhất
            trước chuyến đi 10 ngày làm việc bằng văn bản. Bên A phải hoàn trả
            lại số tiền mà Bên B đã thanh toán (nếu có) và phải chịu phạt vi
            phạm một khoản tiền bằng 8% trên phần giá trị nghĩa vụ Hợp Đồng bị
            vi phạm. Nếu Bên A báo hủy sau thời hạn nêu trên thì Bên A phải bồi
            thường cho Bên B toàn bộ các thiệt hại phát sinh trên thực tế. Thời
            gian Bên A phải thực hiện nghĩa vụ hoàn trả lại tiền đã nhận và/hoặc
            tiền bồi thường nói trên bằng hình thức chuyển khoản trong vòng 02
            tuần làm việc kể từ ngày thông báo bằng văn bản cho Bên B biết.
          </Text>
          <Text style={styles.normal_italic}>
            In the case of Party A failing a part or all of the services under
            the Agreement caused by Party A (except in cases of force majeure in
            Article 9), Party A must be notified to Party B at least before
            departure 10 working days in writing. Party A must reimburse the
            amount that Party B has paid (if any), and shall be fined an amount
            equal to violation of 8% of the value of the agreement obligations
            are violated. If Party A notices cancellation after the deadline
            mentioned above, Party A must compensate Party B for all losses
            incurred in practice. The time Party A to perform the obligation to
            refund money received and/ or compensation above by bank transfer
            within 02 working weeks from the date of written notice to Party B.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>8.2</Text>
            {"     "}Trong trường hợp Bên B báo hủy tour (trừ trường hợp bất khả
            kháng tại Điều 9), thì Bên B phải báo ngay cho Bên A ít nhất trước
            chuyến đi 10 ngày làm việc bằng văn bản. Khi đó, ngoài việc phải
            hoàn trả lại số tiền mà Bên A đã thanh toán cho đối tác thứ ba như
            tiền đặt cọc, phí phạt hủy, phí lệ phí khác (nếu có), Bên B còn bị
            phạt vi phạm một khoản tiền bằng 8% trên tổng giá trị Hợp Đồng bị vi
            phạm.Nếu Bên B báo hủy sau thời hạn nêu trên, Bên B phải chi trả
            100% tổng giá trị Hợp Đồng (trong đó đã bao gồm 70% giá trị Hợp Đồng
            mà Bên B đã thanh toán trong đợt 1).
          </Text>
          <Text style={styles.normal_italic}>
            In case of cancellation of tour party B (except for force majeure in
            Article 9), then Party B shall immediately notify Party A at least
            10 working days before the trip in writing. In such case, apart from
            having to reimburse the amount that Party A has paid to third
            parties, such as deposits, cancellation charges, other charges, and
            fees (if any), Party B shall also be sanctioned an amount equal to
            8% of the total value of the Agreement if violated. If Party B
            cancellations after the deadline mentioned above, Party B must pay
            100% of the Agreement value (in which 70% of the Agreement value
            paid in the first installment is included).
          </Text>

          <Text style={styles.normal}>
            Thời gian Bên B phải thực hiện nghĩa vụ thanh toán tiền mà Bên A đã
            trả cho đối tác và/ hoặc tiền hủy Hợp Đồng, tiền phạt vi phạm nói
            trên bằng hình thức chuyển khoản như đã thỏa thuận trong vòng 02
            tuần làm việc kể từ ngày Bên A thông báo bằng văn bản cho Bên B
            biết.
          </Text>
          <Text style={styles.normal_italic}>
            Time Party B must fulfill the obligation to pay that Party A has
            paid to partners and/ or money to cancel the Agreement, penalties
            for violation of the above in the form of a transfer as agreed
            within 02 working weeks from the date Party A sends written notice
            to Party B.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>8.3</Text>
            {"     "}Nếu Bên B báo hủy khách lẻ thì phải trả chi phí cho Bên A
            theo phương thức như sau:
          </Text>
          <Text style={styles.normal_italic}>
            If Party B cancels retail customers must pay to Party A under the
            following methods:
          </Text>

          <Text style={styles.normal}>
            Sau khi ký Hợp Đồng mà có thành viên trong Đoàn khách của Bên B
            không thể tham gia chuyến đi, thì Bên B phải thông báo cho Bên A
            biết bằng văn bản trước giờ khởi hành và Bên B phải trả chi phí theo
            tỷ lệ phần trăm của giá tour (quy định tại Điều 2) như sau:
          </Text>
          <Text style={styles.normal_italic}>
            After signing the Agreement that members of Party B’s delegation
            could not participate in the trip, then Party B shall notify Party A
            in writing before departure and Party B must pay prorated portion of
            hundreds of tour prices (defined in Article 2) as follows:
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>•</Text>
            {"       "}Sau khi ký Hợp Đồng đến trước ngày khởi hành 45 ngày (trừ
            thứ 7 và Chủ nhật): không phải trả chi phí hủy
          </Text>
          <Text style={styles.normal_italic}>
            After signing the Agreement to 45 days before departure date (except
            Saturday and Sunday): No cancellation fees
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>•</Text>
            {"       "}Sau khi ký Hợp Đồng đến trước ngày khởi hành 30 ngày (trừ
            thứ 7 và Chủ nhật): phải trả chi phí bằng 50 % giá tour/khách
          </Text>
          <Text style={styles.normal_italic}>
            After signing the Agreement to 30 days before departure date (except
            Saturday and Sunday): pay the cost by 50% of the tour/ pax
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>•</Text>
            {"       "}Sau khi ký Hợp Đồng đến ngày khởi hành trong vòng 30 ngày
            (trừ thứ 7 và Chủ nhật: phải trả chi phí bằng 100 % giá tour/ khách.
          </Text>
          <Text style={styles.normal_italic}>
            After signing the Agreement to the departure date within 30 days
            (except Saturday and Sunday): a fee equal to 100% of the tour/ pax
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>•</Text>
            {"       "}Việc nộp phạt, bồi thường thiệt hại phải được hoàn tất
            trong vòng 02 tuần làm việc kể từ khi có yêu cầu của bên bị vi phạm/
            thiệt hại.
          </Text>
          <Text style={styles.normal_italic}>
            The fines and compensation for damages must be completed within 02
            working weeks from the request of the aggrieved party/ damage.
          </Text>

          <Text style={styles.normal_bold}>
            <Text style={styles.normal_bold}>8.4</Text>
            {"     "}Trong thời gian thực hiện chuỵến đi, nếu Bên B hủy bỏ một
            phần dịch vụ vì bất cứ lý do gì thì Bên B sẽ không được Bên A bồi
            hoàn lại giá trị của phần dịch vụ đó và Bên B vẫn phải thanh toán
            toàn bộ giá tour theo Điều 2 của Hợp Đồng này.
          </Text>
          <Text style={styles.normal_italic}>
            During the trip, if party B partially cancels service for any
            reason, Party A will not reimburse the value of that service for
            Party B, and Party B still has to pay the full tour price in
            accordance with Article 2 of this Agreement.
          </Text>

          {/* ĐIỀU 9.	BẤT KHẢ KHÁNG */}
          {/* ARTICLE 9.	FORCE MAJEURE */}
          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 9
            </Text>
            . BẤT KHẢ KHÁNG
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 9
            </Text>
            . FORCE MAJEURE
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>9.1</Text>
            {"     "}Sự kiện bất khả kháng là sự kiện xảy ra một cách khách quan
            không thể lường trước được và không thể khắc phục được mặc dù đã áp
            dụng mọi biện pháp cần thiết và khả năng cho phép.
          </Text>
          <Text style={styles.normal_italic}>
            The force majeure event that occurs objectively can not foresee and
            cannot be overcome despite taking all necessary measures and
            capabilities allow.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>9.2</Text>
            {"     "}Trong trường hợp bất khả kháng như thiên tai (lũ lụt, bão
            tố, động đất, sóng thần và các thảm họa thiên nhiên khác), đình
            công, chiến tranh, khủng bố, biểu tình, dịch bệnh, sự chậm trể, thay
            đổi hoặc hủy bỏ của các hãng hàng không, hãng tàu hoặc các phương
            tiện vận chuyển công cộng khác hoặc các sự kiện khác phù hợp với
            định nghĩa sự kiện bất khả kháng nêu trên nằm ngoài khả năng kiểm
            soát hợp lý của Các Bên, xảy ra không do chủ đích của bên nào thì cả
            Các Bên đều không áp dụng các điều khoản bồi thường và phạt vi phạm
            như quy định đã thoả thuận trong Hợp Đồng này mà chỉ phối hợp cùng
            nhau giải quyết trên cơ sở khắc phục những hậu quả, thiệt hại. Bên
            chịu tác động của sự kiện bất khả kháng có trách nhiệm thông báo kịp
            thời cho Bên còn lại trong vòng 03 ngày kể từ ngày xảy ra sự kiện
            bất khả kháng và có trách nhiệm áp dụng các biện pháp cần thiết để
            hạn chế thiệt hại phát sinh.
          </Text>
          <Text style={styles.normal_italic}>
            In the event of force majeure such as natural disasters (floods,
            hurricanes, earthquakes, tsunamis, and other natural disasters),
            strikes, war, terrorism, protests, epidemic, delays, changes or
            cancellations of airlines, shipping lines or other means of public
            transportation or other events that fit the definition of force
            majeure events mentioned above are beyond the reasonable control of
            the Parties, happened not because of party intent, both Parties will
            not apply the terms of compensation and fines for violations of the
            provisions agreed in the Agreement that only resolved to work
            together on the basis of overcoming the consequences, damages.
            Parties affected by the force majeure event shall be responsible for
            promptly notifying the other party within 03 days of the occurrence
            of force majeure and responsibly applying the necessary measures to
            limit the damage incurred.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>9.3</Text>
            {"     "}Nếu trường hợp bất khả kháng xảy ra khi Hợp Đồng đang được
            thực hiện thì Bên A có trách nhiệm hỗ trợ Khách của Bên B trong việc
            tìm kiếm phương tiện quay về nước hoặc nơi xuất phát, cũng như thức
            ăn và nơi ở trong thời gian Khách ở lại địa phương sở tại. Chi phí
            phát sinh sẽ do Bên B chi trả.
          </Text>
          <Text style={styles.normal_italic}>
            If the case of force majeure occurs when the Agreement is being
            implemented, Party A is responsible for the support of the client of
            Party B in finding means of returning to the country or place of
            origin, as well as food and shelter in Guests staying time the
            local. Costs incurred by Party B will pay.
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 10
            </Text>
            . LUẬT ĐIỀU CHỈNH VÀ GIẢI QUYẾT TRANH CHẤP
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 10
            </Text>
            . GOVERNING LAW AND DISPUTE RESOLUTION
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>10.1</Text>
            {"     "}Hợp Đồng này được giải thích và điều chỉnh theo luật pháp
            của Việt Nam. Mọi thay đổi, bổ sung phải được lập thành văn bản có
            chữ ký xác nhận của đại diện có thẩm quyền của Các Bên.
          </Text>
          <Text style={styles.normal_italic}>
            This Agreement is governed and interpreted under the laws of
            Vietnam. All changes and supplements must be made in writing and
            signed by authorized representatives of both Parties.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>10.2</Text>
            {"     "}Mọi tranh chấp phát sinh từ việc ký kết và thực hiện Hợp
            Đồng này được Các Bên giải quyết bằng thương lượng, hòa giải. Trong
            trường hợp Các Bên không thể giải quyết tranh chấp bằng con đường
            thương lượng hòa giải, trong vòng 30 (ba mươi) ngày làm việc kể từ
            ngày có thông báo về việc phát sinh tranh chấp của một Bên đến Bên
            còn lại, bất kỳ Bên nào cũng có thể đưa tranh chấp đến Trung Tâm
            Trọng Tài Quốc Tế Việt Nam{" "}
            <Text style={styles.normal_bold}>(“VIAC”)</Text> bên cạnh Phòng
            Thương mại và Công nghiệp Việt Nam để giải quyết theo Quy chế tố
            tụng trọng tài hiện hành của VIAC. Địa điểm tiến hành tố tụng trọng
            tài là tại Thành phố Hồ Chí Minh, Việt Nam. Ngôn ngữ tiến hành tố
            tụng trọng tài là tiếng Việt. Phán quyết trọng tài là chung thẩm và
            ràng buộc Các Bên tranh chấp.
          </Text>
          <Text style={styles.normal_italic}>
            Any dispute arising from the signing and implementation of this
            Agreement shall be settled by the Parties’ negotiation and
            mediation. In case no settlement to disputes can be reached through
            amicable negotiation, within 30 (thirty) working days from the date
            of notice of the disputes of one Party to the other Party, either
            Party may refer the disputes to the Vietnam International
            Arbitration Centre <Text style={styles.normal_bold}>(“VIAC”)</Text>{" "}
            at the Vietnam Chamber of Commerce and Industry for its settlement
            in accordance with VIAC’s current Rules of Arbitration. The place of
            the arbitration proceeding shall be in Ho Chi Minh City, Vietnam.
            The language of the arbitration shall be Vietnamese. The award of
            the arbitral tribunal shall be final and binding for the Parties.
          </Text>

          <Text style={styles.normal_bold}>
            <Text
              style={{ ...styles.normal_bold, textDecoration: "underline" }}
            >
              ĐIỀU 11
            </Text>
            . ĐIỀU KHOẢN CHUNG
          </Text>
          <Text style={styles.normal_bold_italic}>
            <Text
              style={{
                ...styles.normal_bold_italic,
                textDecoration: "underline",
              }}
            >
              ARTICLE 11
            </Text>
            . GENERAL PROVISIONS
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>11.1</Text>
            {"     "}Các Bên cam kết thực hiện đúng và đầy đủ các điều khoản đã
            thoả thuận trong Hợp Đồng. Bên nào có nhu cầu thay đổi, bổ sung bất
            kỳ nội dung nào của Hợp Đồng này phải thông báo cho Bên còn lại bằng
            văn bản trước 02 ngày làm việc. Mọi sự thay đổi, bổ sung phải được
            lập thành văn bản do đại diện có thẩm quyền của Các Bên trong Hợp
            Đồng ký tên.
          </Text>

          <Text style={styles.normal_italic}>
            The Parties undertake to comply with and complete the terms agreed
            in the agreement. Any party wishing to change, or supplement any
            content of this Agreement shall notify the other party in writing
            before 02 working days. All changes and supplements must be made in
            writing by the authorized representatives of the parties in the
            agreement signed.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>11.2</Text>
            {"     "}Các Bên đồng ý rằng Hợp Đồng này sẽ có hiệu lực đối với cá
            nhân, tổ chức kế thừa hợp pháp quyền và nghĩa vụ của một trong Các
            Bên của Hợp Đồng này. Bên còn lại có trách nhiệm thực hiện nghiêm
            túc nghĩa vụ của mình trong Hợp Đồng này đối với cá nhân tổ chức kế
            thừa hợp pháp quyền và nghĩa vụ của Bên kia.
          </Text>
          <Text style={styles.normal_italic}>
            The two parties agree that this Agreement shall enter into force for
            individuals and organizations legally inherited rights and
            obligations of either party subject to this agreement. The other
            party shall have to strictly implement its obligations under this
            agreement to the individual organization legally inherit the rights
            and obligations of the other Party.
          </Text>

          <Text style={styles.normal}>
            <Text style={styles.normal_bold}>11.3</Text>
            {"     "}Hợp Đồng được lập thành 02 (hai) bản chính song ngữ Việt -
            Anh có giá trị pháp lý như nhau, theo đó mỗi Bên giữ 01 (một) bản
            chính để thực hiện. Trong trường hợp có mâu thuẫn giữa tiếng Việt và
            tiếng Anh, phần tiếng Việt được ưu tiên áp dụng.
          </Text>
          <Text style={styles.normal_italic}>
            The Agreement is made in 02 (two) bilingual originals in Vietnamese
            – English of the same validity, each Party keeps 01 (one) original
            copy for implementation. In case of any conflicts between Vietnamese
            and English, the Vietnamese content will prevail.
          </Text>

          <div style={{ flexDirection: "row", display: "flex" }}>
            <div style={{ width: "50%", alignItems: "center" }}>
              <Text style={styles.normal_bold}>ĐẠI DIỆN BÊN A</Text>
              <Text style={styles.normal_bold_italic}>
                REPRESENTATIVE OF PARTY A
              </Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>

              <Text style={styles.normal_bold}>Ông/ Mrs. PHẠM ĐỨC LUÂN</Text>
              <Text style={styles.normal}>Giám Đốc</Text>
            </div>
            <div style={{ width: "50%", alignItems: "center" }}>
              <Text style={styles.normal_bold}>ĐẠI DIỆN BÊN B</Text>
              <Text style={styles.normal_bold_italic}>
                REPRESENTATIVE OF PARTY B
              </Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>
              <Text style={styles.normal}></Text>

              <Text style={styles.normal_bold}>{data_pdf.customer_name}</Text>
            </div>
          </div>

          <View break></View>
          <Annex data_pdf={data_pdf} />

          <FooterPageNum />
        </Page>
      </Document>
    );
  }
}
